import { FC, ReactElement, useMemo } from 'react';
import Quantity from '../../Quantity/Quantity';
import SingleChoiceOption from '../../SingleChoice/components/SingleChoiceOption';
import { ICurrencySettings } from 'src/types/branches';
import { IResponseProductModifierOption } from 'src/types/products';

interface IProps {
  option: IResponseProductModifierOption;
  onPressOption: (option: IResponseProductModifierOption) => void;
  onChangeOptionQuantity: (id: IResponseProductModifierOption['id'], quantity: number) => void;
  uniq: boolean;
  leftToMaximum: number;
  currencySettings?: ICurrencySettings;
}

const MultiChoiceOption: FC<IProps> = ({ option, ...props }: IProps): ReactElement => {
  const onQuantityChange = (quantity: number) => {
    props.onChangeOptionQuantity(option.id, quantity);
  };

  const availableQuantityBlock = useMemo((): boolean => Boolean(option.selected && !props.uniq && option.maximum > 1), [option]);

  return (
    <SingleChoiceOption
      key={option.id}
      option={option}
      onPressOption={props.onPressOption}
      currencySettings={props.currencySettings}
      appearance="square">
      {availableQuantityBlock ? (
        <Quantity
          value={option.quantity}
          onChange={onQuantityChange}
          decreaseId={`decrease_${option.id}`}
          increaseId={`increase_${option.id}`}
          maximum={option.maximum}
          minimum={option.minimum}
          plusButtonDisabled={props.leftToMaximum <= 0}
          small
        />
      ) : null}
    </SingleChoiceOption>
  );
};

export default MultiChoiceOption;
